<form [formGroup]="filterGroup" class="module-filter-form">
    <div class="module-filter-form-filters">
        <ng-container *ngFor="let filter of filterList">
            <div [ngSwitch]="filter.type" class="module-filter-form-filters-container"
                [ngClass]="{'full-line': filter.fullLine}">

                <!-- Basic text search -->
                <input *ngSwitchCase="type.TEXT" [formControlName]="filter.key" [placeholder]="filter.label"
                    type="text">

                <!-- Chip list -->
                <mat-chip-listbox *ngSwitchCase="type.CHIP" [formControlName]="filter.key" multiple>
                    <!-- <mat-chip-option *ngFor="let status of filter.list" [value]="status.value">{{
                        status.label }}
                    </mat-chip-option> -->
                    <mat-chip-option *ngFor="let status of filter.options | async" [value]="status.value">{{
                        status.label }}
                    </mat-chip-option>
                </mat-chip-listbox>

                <!-- Dropdown filter -->
                <dropdown-filter *ngSwitchCase="type.LISTCHIP" [formControlName]="filter.key"
                    [formControl]="control(filter.key)" [options]="filter.options | async" [label]="filter.label" />

                <!-- Default message -->
                <div *ngSwitchDefault> Tipo de control no válido </div>

                <!-- Suffix icon -->
                <sit-icon *ngIf="filter.type === type.TEXT && filter.suffixIcon" [icon]="filter.suffixIcon"
                    [ngClass]="'suffix-icon'" />
            </div>
        </ng-container>
    </div>
    <div class="module-filter-form-controls">
        <sit-button [buttonProperties]="searchButtonAttributes" (click)="onSearch()"></sit-button>
        <sit-button [buttonProperties]="cleanbuttonAttributes" (click)="onClean()"></sit-button>
    </div>
</form>